/* © CNES */

import { ExecutionReport } from '../../../../../models/ExecutionReport';

/**
 * Log Context displays information about all jobs for a user logged in.
 * @param contextInfoDetails a list of processings.
 * @returns Element.
 */
export const LogContext = ({
  executionReport,
}: {
  executionReport: ExecutionReport;
}) => {
  return (
    <>
      <pre>
        <code>{JSON.stringify(executionReport?.USER_INFO, null, 4)}</code>
      </pre>
    </>
  );
};
